import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';
import { LinkContainer } from 'react-router-bootstrap';
import { SUPPORT_EMAIL } from '../../../constants/constants';

const AccountGuide = () => {
  return (
    <>
    <Meta>
        title='アカウントについて | ふるぷら'
        description='アカウント情報の更新について説明するページです。'
        keywords={['ふるぷら', '古着', '解約', 'パスワード']}
    </Meta>
    <Container className='my-5'>
        <Row className='justify-content-center'>
            <Col xs={12} md={8} lg={5}>
                <section className='accountguide-1'>
                    <h1 className="fs-3 mb-4 text-center">アカウントについて</h1>
                        <h2 className='fs-5 fw-bold'>ログインできない時</h2>
                            <p>
                                【パスワードを忘れた場合】<br />
                                現在、ふるぷらのECサイト上では、ログイン画面では、パスワードを忘れた場合ご対応ができません。<br />
                                お手数をおかけし、大変申し訳ございませんが、本サイトに未ログインの状態でパスワードをお客様は、<br />
                                <a
                                    href={`mailto:${SUPPORT_EMAIL}`}
                                    style={{ marginLeft: '0.5rem', color: '#0070f3' }}
                                >
                                    {SUPPORT_EMAIL}
                                </a>
                                または公式LINEにご連絡ください。
                            </p>
                        <h2 className='fs-5 fw-bold'>パスワード・メールアドレスの再設定</h2>
                            <p>
                                ふるぷらECサイトのサイト上部にあるサイドバーの👤＞＞【プロフィール】から、アカウントのメールアドレス及びパスワードが変更ができます。
                            </p>
                        <h2 className='fs-5 fw-bold'>プランの変更・解約</h2>
                            <p>
                                1．ふるぷらECサイトのサイト上部にあるサイドバーの👤＞＞【プロフィール】を選択してください。<br />
                                2．【サブスクリプション】＞＞【プランを変更】を選択してください。<br />
                                3．プランを解約または変更してください。<br />
                                <span className='fs-6 fw-bold text-info'>【解約】</span><br />
                                ・【サブスクリプションをキャンセル】を選択してください。<br />
                                <span className='fs-6 fw-bold text-info'>【変更】</span><br />
                                ・【サブスクリプションを更新する】を選択してください。<br />
                                ・新たにご利用したいプランを選択し、【続行】を押してください。<br />
                                4．【プロフィール】を確認し、【サブスクリプション】のプラン内容が変更されていれば、解約・変更手続き完了です。<br />
                            </p>
                </section>
            </Col>
        </Row>
    </Container>
    </>
  )
}

export default AccountGuide